import { TRootState } from "store";
import { IContractsState } from "./contracts.types";

export const getContractsSelector = (state: TRootState): IContractsState => state.contracts;
